import { NotificationsService } from '@notifications/infra';
import { inject } from '@angular/core';
import { Observable, of, take, tap } from 'rxjs';
import { PLATFORM_TOKEN, PlatformProvider } from '@core';
import { UnregisterDeviceTokenPathParams } from '@core-http';

export class UnregisterTokenCommandHandler {
  private readonly notificationsService: NotificationsService = inject(NotificationsService);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);

  unregister(): Observable<void> {
    const token: string = localStorage.getItem('FCM_Device_Token') as string;

    if (this.platformProvider.isNativeRun) {
      const pathParams: UnregisterDeviceTokenPathParams = { token };

      return this.notificationsService.unregisterToken(pathParams).pipe(
        take(1),
        tap(() => localStorage.removeItem('FCM_Device_Token'))
      );
    }

    return of(void 0);
  }
}
